/**
 * Product Subnavigation Scroll Spy
 * - Adds 'active' class to navigation items as user scrolls through sections
 * - Uses Intersection Observer API (modern replacement for Waypoints)
 */

document.addEventListener('DOMContentLoaded', function() {
  const subnav = document.getElementById('product_subnav');
  if (!subnav) return;

  const navItems = subnav.querySelectorAll('.subnav-item');
  const sections = [];

  // Build array of sections with their corresponding nav items
  navItems.forEach(item => {
    const sectionId = item.getAttribute('data-section');
    const section = document.getElementById(sectionId);
    if (section) {
      sections.push({
        element: section,
        navItem: item,
        id: sectionId
      });
    }
  });

  if (sections.length === 0) return;

  // Set first item as active by default
  sections[0].navItem.classList.add('active');

  // Create Intersection Observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        // Find the section that's currently in view
        if (entry.isIntersecting) {
          const activeSection = sections.find(
            s => s.element === entry.target
          );
          
          if (activeSection) {
            // Remove active class from all nav items
            navItems.forEach(item => item.classList.remove('active'));
            
            // Add active class to current section's nav item
            activeSection.navItem.classList.add('active');
          }
        }
      });
    },
    {
      // Trigger when section is 85px from top (matching WordPress offset)
      rootMargin: '-85px 0px -75% 0px',
      threshold: 0
    }
  );

  // Observe all sections
  sections.forEach(section => {
    observer.observe(section.element);
  });

  // Smooth scroll for jump links
  navItems.forEach(item => {
    const link = item.querySelector('a');
    if (link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const target = document.getElementById(targetId);
        
        if (target) {
          // Calculate offset to account for sticky subnav height
          const subnavHeight = subnav.offsetHeight;
          const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - subnavHeight - 10;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    }
  });
});
